<template>
    <div class="QCReportMetric">
        <!--List report metrics-->
        <div class="p-12 content-tab fci-scrollbar">
            <v-form v-model="formValid" ref="form">
                <table class="table-report-metrics">
                    <thead>
                        <tr>
                            <th
                                scope="col"
                                class="text-left"
                                style="width: 300px"
                            >
                                {{ this.$f.tc("name") }}
                            </th>
                            <th
                                scope="col"
                                class="text-left"
                                style="width: 530px"
                            >
                                {{ this.$f.tc("formula") }}
                            </th>
                            <th
                                scope="col"
                                class="text-left"
                                style="width: 300px"
                            >
                                {{ this.$f.tc("description") }}
                            </th>
                            <th></th>
                        </tr>
                    </thead>

                    <!--Loading table-->
                    <tbody v-if="isLoading">
                        <tr>
                            <td :colspan="4">
                                <div class="centerXY">
                                    <v-progress-circular
                                        indeterminate
                                        color="primary"
                                        style="width: 22px"
                                        class="mr-8"
                                    ></v-progress-circular>
                                    {{ $f.tc("loadingData") }}
                                </div>
                            </td>
                        </tr>
                    </tbody>

                    <template v-else>
                        <!--Draggable metrics-->
                        <draggable
                            v-model="reportMetrics"
                            tag="tbody"
                            :move="onMoveCallback"
                            :clone="onCloneCallback"
                            @end="onDropCallback"
                        >
                            <tr v-for="(item, index) in reportMetrics" :key="`report_metric_${index}`" :class="item.id === editModel.id ? 'row-edit' : ''">
                                <td>
                                    <v-text-field
                                        v-if="item.id === editModel.id"
                                        v-model="editModel.name"
                                        class="input-custom"
                                        :rules="formRules.required"
                                        ref="MetricName"
                                    ></v-text-field>
                                    <span v-else>{{ item.name }}</span>
                                </td>
                                <td>
                                    <v-text-field
                                        v-if="item.id === editModel.id"
                                        v-model="editModel.formula"
                                        class="input-custom"
                                        :rules="formRules.required"
                                    ></v-text-field>
                                    <span v-else>{{ item.formula }}</span>
                                </td>
                                <td>
                                    <v-text-field
                                        v-if="item.id === editModel.id"
                                        v-model="editModel.description"
                                        class="input-custom"
                                    ></v-text-field>
                                    <span v-else>{{ item.description }}</span>
                                </td>
                                <td>
                                    <div
                                        v-if="item.id === editModel.id"
                                        class="centerXY"
                                    >
                                        <div
                                            class="btn-icon mr-1"
                                            @click="closeEdit"
                                        >
                                            <img
                                                src="/img/close.svg"
                                                alt="icon-config"
                                            />
                                        </div>
                                        <div
                                            class="btn-icon"
                                            @click="saveEdit(item)"
                                        >
                                            <img
                                                src="/img/save-member-2.svg"
                                                alt="icon-save-config"
                                            />
                                        </div>
                                    </div>
                                    <div v-else class="centerXY">
                                        <div
                                            class="btn-icon mr-1"
                                            @click="editReportMetric(item)"
                                        >
                                            <img
                                                src="/img/edit-2.svg"
                                                alt="icon-edit"
                                            />
                                        </div>
                                        <div
                                            class="btn-icon"
                                            @click="deleteReportMetric(item)"
                                        >
                                            <img
                                                src="/img/delete-new.svg"
                                                alt="icon-delete"
                                            />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </draggable>

                        <!--Add new metric-->
                        <tbody>
                            <tr
                                v-if="!isShowAddItem"
                                @click="openFormAddNew"
                                style="cursor: pointer"
                            >
                                <td :colspan="4">
                                    <img
                                        src="/img/add-member.svg"
                                        alt="icon-add"
                                        style="padding-right: 6px"
                                    />
                                    {{ $f.tc("addNew") }}
                                </td>
                            </tr>
                            <tr v-else class="row-edit">
                                <td>
                                    <v-text-field
                                        v-model="model.name"
                                        class="input-custom"
                                        :rules="formRules.required"
                                        ref="NewMetricName"
                                    ></v-text-field>
                                </td>
                                <td>
                                    <v-text-field
                                        v-model="model.formula"
                                        class="input-custom"
                                        :rules="formRules.required"
                                    ></v-text-field>
                                </td>
                                <td>
                                    <v-text-field
                                        v-model="model.description"
                                        class="input-custom"
                                    ></v-text-field>
                                </td>
                                <td>
                                    <div class="centerXY">
                                        <div
                                            @click="closeFormAddItem"
                                            class="btn-icon mr-6"
                                        >
                                            <img
                                                src="/img/close.svg"
                                                alt="icon-config"
                                            />
                                        </div>
                                        <div
                                            class="btn-icon"
                                            @click="addReportMetric"
                                        >
                                            <img
                                                src="/img/save-member-2.svg"
                                                alt="icon-save"
                                            />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </table>
            </v-form>
        </div>
    </div>
</template>

<script>
import FormMixin from "@/modules/fptai/mixins/FormMixin";
import RoleMixin from "@/modules/fptai/mixins/RoleMixin";
import { mapState } from "vuex";
import draggable from "vuedraggable";
import lodash from "lodash";
import $filters from "@/modules/fptai/filters/filters";

const defaultModel = {
    name: "",
    formula: "",
    description: ""
};

export default {
    name: "QCReportMetric",
    components: { draggable },
    mixins: [FormMixin, RoleMixin],
    props: {
        hideFooter: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showConfirmOverlay: false,
            isShowAddItem: false,
            isLoading: true,
            model: this.$utils.cloneObject(defaultModel),
            editModel: {},
            editModelIndex: -1,
            dragFrom: {},
            dragTo: {}
        };
    },
    computed: {
        ...mapState({
            qcCampaign: state => state.qccampaign.campaign,
            reportMetrics: state => state.qccampaign.reportMetrics
        })
    },
    mounted() {
        this.getReportMetrics();
    },
    methods: {
        async getReportMetrics() {
            if (!this.qcCampaign.id) return;
            try {
                this.isLoading = true;
                await this.$store.dispatch(
                    this.$actionTypes.qccampaign.GET_REPORT_METRICS,
                    this.qcCampaign.id
                );
                this.isLoading = false;
            } catch {
                this.isLoading = false;
            }
        },
        async addReportMetric() {
            this.$refs.form.validate();
            if (!this.model.name || !this.model.formula) return;
            if (!this.qcCampaign.id) return;
            try {
                this.isLoading = true;
                await this.$store.dispatch(
                    this.$actionTypes.qccampaign.CREATE_REPORT_METRIC,
                    {
                        qcCampaignID: this.qcCampaign.id,
                        model: this.model
                    }
                );
                
                await this.getReportMetrics();
                this.$appService.toastSuccess($filters.tc("createItemSuccess"));
                this.model = this.$utils.cloneObject(defaultModel);
                this.$refs.form.resetValidation();
            } catch {
                this.isLoading = false;
            }
        },
        async deleteReportMetric(item) {
            if (this.editModel.id) {
                this.$appService.toastWarning($filters.tc('pleaseFinishEditBeforeDelete'))
                return;
            }
            if (!item) return;
            if (!this.qcCampaign.id || !item.id) return;
            try {
                let confirm = await this.$appService.confirm(
                    this.$f.tc("confirmDeleteReportMetric", { name: item.name })
                );
                if (!confirm) return;
                this.isLoading = true;
                await this.$store.dispatch(
                    this.$actionTypes.qccampaign.DELETE_REPORT_METRIC,
                    {
                        qcCampaignID: this.qcCampaign.id,
                        reportMetricId: item.id
                    }
                );
                await this.getReportMetrics();
                this.$appService.toastSuccess($filters.tc('deleteItemSuccess'))
            } catch {
                this.isLoading = false;
            }
        },
        editReportMetric(item) {
            if (this.editModel.id) {
                this.$appService.toastWarning($filters.tc('pleaseFinishEditBeforeAction'))
                return;
            }
            this.closeFormAddItem()
            this.editModelIndex = this.reportMetrics.indexOf(item);
            this.editModel = this.$utils.cloneObject(item);
            
            this.$nextTick(() => {
                this.$refs.MetricName[0].focus()
            })
        },
        closeEdit() {
            this.editModel = {};
            this.editModelIndex = -1;
        },
        async saveEdit(item) {
            if (
                lodash.isEqual(this.editModel, item) ||
                this.editModelIndex < 0
            ) {
                this.closeEdit();
                return;
            }
            
            if (!this.editModel.name || !this.editModel.formula) return;
            
            try {
                this.isLoading = true;
                await this.$store.dispatch(
                    this.$actionTypes.qccampaign.UPDATE_REPORT_METRIC,
                    {
                        qcCampaignID: this.qcCampaign.id,
                        reportMetricId: item.id,
                        model: this.editModel
                    }
                );
                
                await this.getReportMetrics();
                this.$appService.toastSuccess($filters.tc('updateItemSuccess'))
                this.closeEdit();
            } catch {
                this.isLoading = false;
            }
        },
        openFormAddNew() {
            this.$refs.form.validate();
            if (this.editModel.id) {
                this.$appService.toastWarning($filters.tc('pleaseFinishEditBeforeAdd'))
                return;
            }
            this.isShowAddItem = true;
            
            this.$nextTick(() => {
                this.$refs.NewMetricName.focus()
            })
        },
        closeFormAddItem() {
            this.isShowAddItem = false;
            this.model = this.$utils.cloneObject(defaultModel);
        },

        // method for drag and drop
        onCloneCallback(item) {
            return this.$utils.cloneObject(item);
        },
        onMoveCallback(evt) {
            this.dragFrom = evt.draggedContext.element;
            this.dragTo = evt.relatedContext.element;
            return !this.dragFrom.locked;
        },
        async onDropCallback() {
            if (this.dragFrom.id === this.dragTo.id) {
                return;
            }

            let model = {
                old_id: this.dragFrom.id,
                new_id: this.dragTo.id
            };
            try {
                this.isLoading = true;
                await this.$store.dispatch(
                    this.$actionTypes.qccampaign.SWAP_REPORT_METRIC,
                    {
                        qcCampaignID: this.qcCampaign.id,
                        model: model
                    }
                );
                this.dragFrom = {}
                this.dragTo = {}
                await this.getReportMetrics();
                this.$appService.toastSuccess($filters.tc('swapOrderSuccess'))
            } catch {
                this.isLoading = false;
            }
        },
    }
};
</script>
<style scoped lang="scss">
.QCReportMetric {
    font-size: 14px !important;

    .btn-icon {
        img {
            transform: scale(0.9);
        }
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 40px;
            background: #ffffff;
            border-radius: 0;
            border: none !important;
            outline: none;
            font-size: 14px;
            padding: 0;
            margin: 0;
            display: flex;
            align-items: center;

            &:before,
            &:after {
                border: none !important;
            }
        }

        .v-label {
            background: #ffffff !important;
            padding: 0 6px;

            &:not(.v-label--active) {
                font-size: 14px !important;
                padding-left: 0 !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-input__control {
        position: relative;
    }

    .table-report-metrics {
        width: 100%;
        font-size: 14px;
        font-family: "open sans", serif !important;
        border: 1px solid #dadfec;
        border-collapse: collapse;
        border-spacing: 0;

        thead tr:not(.v-datatable__progress) {
            height: 40px !important;
            border-bottom: none;
            padding: 0 !important;
        }

        thead tr th {
            text-transform: capitalize !important;
            color: #12274f !important;
            background: #f4f7fe;
            border-right: 1px solid #dadfec;
            padding: 0 10px;

            &:last-child {
                border-right: none;
            }
        }

        tbody tr td {
            height: 40px !important;
            border-right: 1px solid #dadfec;
            padding: 0 10px;
            border-top: 1px solid #dadfec;

            &:last-child {
                border-right: none;
            }
        }

        .v-text-field__details {
            position: absolute;
            right: 0 !important;
            top: 11px !important;
        }
    }
    
    .row-edit {
        background: #F4F7FE;
        .v-input__slot {
            background: #F4F7FE !important;
        }
    }
}
</style>
